import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import SlideToggle from "../common/form/SlideToggle";
import FormDrawer from "../common/form-drawer";
import { ButtonLoader, SelectInput } from "../common/form";
import * as walletAction from 'store/entities/wallet/action';
import * as notificationAction from 'store/entities/notification/action';

const AccountSetting = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const {
        isOpen,
        setIsOpen,
        accountDetails,
    } = props;
    const { 
        updatedWalletAccountLoading,
        updatedWalletAccount
    } = useSelector(s => s.entities.wallet)
    const { data } = accountDetails;
    const [toggleActive, setToggleActive] = useState(false);

    const [form, setForm] = useState({
        isPrimaryAccount: "",
        walletType: ""
    })

    const handleAccountChange = (e) => {
        setForm({
            ...form,
            walletType: e.target.value
        });
    };

    const submitForm = (e) => {
        e.preventDefault();

        const payload = {
            isPrimaryAccount: toggleActive,
            walletType: form?.walletType,
        };
        const { walletId } = accountDetails?.data;
        dispatch(walletAction.updateAccount(payload, walletId))
    };

    useEffect(() => {
        if (data) {
            setForm({
                isPrimaryAccount: data?.isPrimaryAccount,
                walletType: data?.companyAccountType || ""
            });
            setToggleActive(data?.isPrimaryAccount || false);
        }
    }, [data]);
    
    useEffect(() => {
        if (updatedWalletAccount?.status === "success") {
            toast.success(updatedWalletAccount?.message);
            setIsOpen(false);
            history.push('/account/all-accounts');
            dispatch(walletAction.resetUpdateWalletAccount())
            dispatch(notificationAction.getAllNotifications())
        }
    }, [updatedWalletAccount, dispatch, history, setIsOpen])

    return (
        <>
            <FormDrawer display="center" size="lg" isOpen={isOpen} setIsOpen={setIsOpen}>
                <div className="p-6">
                    <FormDrawer.Title
                        title="Account Settings"
                        description="Make changes to this subaccount"
                        showCloseButton={true}
                        close={setIsOpen}
                    />
                    <hr className="w-full h-px mt-2 bg-[#E2E4E8] border-none" />

                    <form onSubmit={submitForm}>
                        <div className="my-4">
                            <SelectInput
                                label="Account Type"
                                value={form?.walletType || ""}
                                onChange={handleAccountChange}
                            >
                                <option value="">Select an account type</option>
                                <option value="expense">Expense Account</option>
                                <option value="collection">Collection Account</option>
                            </SelectInput>
                        </div>

                        <div className="flex justify-between space-x-2">
                            <div>
                                <div className="mb-3 font-medium">Set As Primary Account</div>
                                <div className="text-[#718096]">
                                    Receive alerts when there is an account funding or transfer done
                                </div>
                            </div>
                            <SlideToggle
                                onChange={() => setToggleActive(!toggleActive)}
                                active={toggleActive}
                            />
                        </div>

                        <div className="mt-4 flex justify-end space-x-4">
                            <button type="button" onClick={() => setIsOpen(false)} className="btn btn-lg btn-transparent-primary">
                                Cancel
                            </button>
                            <ButtonLoader loading={updatedWalletAccountLoading} type="submit" className="btn btn-lg btn-ep-primary">
                                Save Changes
                            </ButtonLoader>
                        </div>
                    </form>
                </div>
            </FormDrawer>
        </>
    )
}

export default AccountSetting;